/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssignedUser } from './AssignedUser';
import {
    AssignedUserFromJSON,
    AssignedUserFromJSONTyped,
    AssignedUserToJSON,
    AssignedUserToJSONTyped,
} from './AssignedUser';

/**
 * 
 * @export
 * @interface GetClaimAssignees200Response
 */
export interface GetClaimAssignees200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetClaimAssignees200Response
     */
    success?: boolean;
    /**
     * 
     * @type {Array<AssignedUser>}
     * @memberof GetClaimAssignees200Response
     */
    data?: Array<AssignedUser>;
}

/**
 * Check if a given object implements the GetClaimAssignees200Response interface.
 */
export function instanceOfGetClaimAssignees200Response(value: object): value is GetClaimAssignees200Response {
    return true;
}

export function GetClaimAssignees200ResponseFromJSON(json: any): GetClaimAssignees200Response {
    return GetClaimAssignees200ResponseFromJSONTyped(json, false);
}

export function GetClaimAssignees200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetClaimAssignees200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(AssignedUserFromJSON)),
    };
}

export function GetClaimAssignees200ResponseToJSON(json: any): GetClaimAssignees200Response {
    return GetClaimAssignees200ResponseToJSONTyped(json, false);
}

export function GetClaimAssignees200ResponseToJSONTyped(value?: GetClaimAssignees200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(AssignedUserToJSON)),
    };
}

